import React from 'react';
import './popup-base.scss';

function base({popupClass, closePopup, title, children}) {
    return (
        <div className={`${popupClass} centered`}>
            <header>
                <a href="#!" className="btn-close" onClick={closePopup}>&times;</a>
                <h2>{title}</h2>
            </header>
            {children}
        </div>
    );
}

export default base;


// WEBPACK FOOTER //
// ./src/fPopup/popup_types/base/index.js